
import { defineComponent, computed } from 'vue'

// Composables
import { useTitle } from '@vueuse/core'
import { useRoute } from '@/use/router'
import { useProject } from '@/org/use-projects'
import { useTelegramNotifChannel } from '@/alerting/use-notif-channels'

// Components
import NotifChannelTelegramForm from '@/alerting/NotifChannelTelegramForm.vue'

export default defineComponent({
  name: 'ChannelShowTelegram',
  components: { NotifChannelTelegramForm },

  setup() {
    useTitle('Telegram Channel')
    const route = useRoute()
    const project = useProject()

    const channel = useTelegramNotifChannel(() => {
      const { projectId, channelId } = route.value.params
      return {
        url: `/internal/v1/projects/${projectId}/notification-channels/telegram/${channelId}`,
      }
    })

    const breadcrumbs = computed(() => {
      const bs: any[] = []

      bs.push({
        text: project.data?.name ?? 'Project',
        to: {
          name: 'ProjectShow',
        },
        exact: true,
      })

      bs.push({
        text: 'Channels',
        to: {
          name: 'NotifChannelList',
        },
        exact: true,
      })

      bs.push({ text: 'Telegram' })

      return bs
    })

    return { channel, breadcrumbs }
  },
})
